import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";

import FilledButton from "../../components/buttons/FilledButton";
import { loadStats, selectStatsState } from "./flowStatsSlice";

export default function RefreshButton({
  flowId,
}: {
  flowId: number;
}): ReactElement {
  const dispatch = useDispatch();
  const { loading } = useSelector(selectStatsState);

  return (
    <FilledButton
      onClick={() => {
        dispatch(loadStats({ flowId, force: true }));
      }}
      disabled={loading === "pending"}
    >
      Refresh
    </FilledButton>
  );
}
